export default class CohortMapping {

    mapData(cohort) {
        return {
            id: cohort ? cohort.id : null,
            name: cohort ? cohort.name : null,
            description: cohort ? cohort.description : null,
            status: cohort ? cohort.status : null,
            owner_id: cohort ? cohort.owner_id : null,
            owner: cohort ? cohort.owner : null,
            learners_count: cohort ? cohort.learners_count : 0,
            instructors_count: cohort ? cohort.instructors_count : 0,
            created_at: cohort ? cohort.created_at : null,
            is_parent: cohort ? cohort.is_parent : false,
            is_child: cohort ? cohort.is_child : false,
            parents: cohort ? cohort.parents : [],
            children: cohort ? cohort.children : [],
        }
    }

    unmapData(data) {
        return data
    }
}
